export default "__VITE_ASSET__ZK_z2OLX__"